export default __webpack_public_path__ + "static/media/BF.a08af8d4.png";